const DataSort = Object.freeze({
    ASC: 'ASC',
    DESC: 'DESC',
});

const HttpMethods = Object.freeze({
    POST: 'POST',
    PUT: 'PUT',
    GET: 'GET',
    DELETE: 'DELETE',
});

const HttpCodes = Object.freeze({
    UNAUTHORIZED: 401,
});

const NOTIFICATION_TYPE = {
    SMS_RECEIVED: 'SMS_RECEIVED',
    EMAIL_RECEIVED: 'EMAIL_RECEIVED',
    REMINDER_EVENT: 'REMINDER_EVENT',
    REMINDER_CALL: 'REMINDER_CALL',
    REMINDER_TASK: 'REMINDER_TASK',
    CREATE_REPORT: 'CREATE_REPORT',
    OPPORTUNITY_ASSIGN: 'OPPORTUNITY_ASSIGN',
    OPPORTUNITY_UPDATE: 'OPPORTUNITY_UPDATE',
};

const FetchPolicy = Object.freeze({
    NETWORK_ONLY: 'network-only',
    NO_CACHE: 'no-cache',
    CACHE_FIRST: 'cache-first',
});

const ClientId = {
    WEB: 'Web',
};

const Tables = {
    INVENTORY_MAIN_LIST: 'Inventory Main List',
};

const WATERMARK_SPOTS = {
    TOP_LEFT: 'Top Left',
    TOP_CENTER: 'Top Center',
    TOP_RIGHT: 'Top Right',
    CENTER: ' Center',
    CENTER_LEFT: 'Center Left',
    CENTER_RIGHT: 'Center Right',
    BOTTOM_LEFT: 'Bottom Left',
    BOTTOM_CENTER: 'Bottom Center',
    BOTTOM_RIGHT: 'Bottom Right',
    OVERLAY: 'Overlay',
};

const ProcessTypeDescription = Object.freeze({
    PURCHASE_ORDER: 'Purchase Order',
    CHECK: 'Check',
    DEPOSIT: 'Deposit',
    BILL: 'Bill',
    PARTS_TICKET: 'Parts Ticket',
});

const DOCUMENT_REFERENCE_TYPE = {
    INVENTORY: 'Inventory',
    DEALS: 'Deals',
    DEAL: 'Deal',
    CRM: 'CRM',
    CUSTOMER: 'Customer',
    CHECK: 'Check',
    DEPOSIT: 'Deposit',
    BILL: 'Bill',
    PURCHASE_ORDER: 'Purchase Order',
    SERVICE_JOB: 'Service Job',
    VENDOR: 'Vendor',
};

const AI_PLATFORM = {
    OPEN_AI: 'Open AI',
    VAPI: 'VAPI',
};

export const AI_API = Object.freeze({
    API_VERSION_1: 'API Version 1',
    API_VERSION_2: 'API Version 2',
});

const AI_CUSTOM_FUNCTION_ROLE = {
    AI_COLLECTOR: 'AI Collector',
    AI_WEB_CHAT: 'AI Web Chat',
    AI_VEHICLE_DESCRIPTION: 'AI Vehicle Description',
    AI_RECON_APPROVAL: 'AI Recon Approval',
    AI_SMART_ANALYST: 'AI Smart Analyst',
    AI_CRM_AGENT: 'AI CRM Agent',
    AI_VOICE_AGENT: 'AI Voice Agent',
};

const CALENDAR_SOURCE = {
    SERVICE: 'Service',
    CRM: 'CRM',
};

const MEDIA_QUERY = Object.freeze({
    W_430: 430,
    W_992: 992,
});

const ALL_LOTS = 'All Lots';
export {
    DataSort, HttpMethods, HttpCodes, FetchPolicy, ClientId,
    Tables, ALL_LOTS, NOTIFICATION_TYPE, WATERMARK_SPOTS,
    ProcessTypeDescription, DOCUMENT_REFERENCE_TYPE,
    AI_PLATFORM, AI_CUSTOM_FUNCTION_ROLE, CALENDAR_SOURCE,
    MEDIA_QUERY,
};
